import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { MdKeyboardArrowLeft } from 'react-icons/md'

const BackLinkButton = ({ destination }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Button variant="link" style={{ textDecoration: "none", width: "fit-content" }} onClick={() => navigate(destination ?? "./..")}><MdKeyboardArrowLeft />{t("general_back")}</Button>
  )
}

export default BackLinkButton